export default __webpack_public_path__ + "static/media/fa-solid-900.4a83f63f.woff2";